jQuery(document).ready(function($) {
    const morePostsBtn = $('#btn-load-more');
    morePostsBtn.click(function() {
        const latestPostDate = $('.module-layotterblogteaseroverview').find('.teaser-area').children().last().data('post-date');
        morePostsBtn.addClass('disabled').attr('disabled', true);
        loadMorePosts(latestPostDate);
    });

    const moreDownloadsBtn = $('#btn-load-more-downloads');
    moreDownloadsBtn.click(function() {
        const latestDownloadDate = $('.module-layotterdownloadsoverview').find('.teaser-area').children().last().data('post-date');
        moreDownloadsBtn.addClass('disabled').attr('disabled', true);
        loadMoreDownloads(latestDownloadDate);
    });

    /**
     * copy teaser template, fill it & append copy to DOM
     * 
     * @param {*} data 
     */
    function appendResult(data) {
        posts = JSON.parse(data);

        if (posts.length > 0) {
            posts.forEach(function(post) {
                let template = $('.module-layotterblogteaseroverview').find('#teaser-template').clone();

                if (post.preview_image_url) {
                    template.find('.teaser--image').attr('style', 'background-image: url(' + post.preview_image_url + ')');
                } else {
                    template.find('.teaser--image').remove();
                }

                if (post.categories) {
                    post.categories.forEach(function(category, i) {
                        template.find('.categories').append('<div class="category" data-id="' + category.id + '">' + category.name + '</div>');
                    });
                }

                template.find('.headline').html(post.title);
                template.find('.text').html(post.text);
                template.find('.more-link').attr('href', post.permalink);
                template.attr('data-post-date', post.post_date);
                template.removeAttr('id');

                $('.module-layotterblogteaseroverview').find('.teaser-area').append(template);
                $('#btn-load-more').removeClass('disabled').attr('disabled', false);
            });
        } else {
            $('.module-layotterblogteaseroverview').find('#no-more-posts').removeClass('d-none');
            $('#btn-load-more').remove();
        }
    }

    /**
     * copy teaser template, fill it & append copy to DOM
     * 
     * @param {*} data 
     */
    function appendResultDownloads(data) {        
        downloads = JSON.parse(data);

        if (downloads.length > 0) {
            downloads.forEach(function(download) {
                let template = $('.module-layotterdownloadsoverview').find('#teaser-template').clone();

                if (download.image_url) {
                    template.find('.teaser--image').attr('style', 'background-image: url(' + download.image_url + ')');
                } else {
                    template.find('.teaser--image').remove();
                }

                if (download.categories) {
                    download.categories.forEach(function(category, i) {
                        template.find('.categories').append('<div class="category" data-id="' + category.id + '">' + category.name + '</div>');
                    });
                }

                template.find('.headline').html(download.title);
                template.find('.headline').html(download.title);
                template.find('.text').html(download.description); 
                template.find('.download-link').attr('href', download.file_url);
                template.find('.file-type').html(download.file_type);
                template.find('.file-size').html(download.file_size);
                template.attr('data-post-date', download.post_date);
                template.removeAttr('id');

                $('.module-layotterdownloadsoverview').find('.teaser-area').append(template);
                $('#btn-load-more-downloads').removeClass('disabled').attr('disabled', false);
            });
        } else {
            $('.module-layotterdownloadsoverview').find('#no-more-posts').removeClass('d-none');
            $('#btn-load-more-downloads').remove();
        }
    }

    /**
     * call ajax action & call function for processing results
     *  
     * @param {*} latestPostDate 
     */
    function loadMorePosts(latestPostDate) {
        const action_url = '/cms/wp-admin/admin-ajax.php?action=load_more_posts';

        $.post(action_url, {latest: latestPostDate}, function(data) {
            appendResult(data);
        }); 
    }

    /**
     * call ajax action & call function for processing results
     *  
     * @param {*} latestDownloadDate 
     */
    function loadMoreDownloads(latestDownloadDate) {
        const action_url = '/cms/wp-admin/admin-ajax.php?action=load_more_downloads';

        $.post(action_url, {latest: latestDownloadDate}, function(data) {
            appendResultDownloads(data);
        }); 
    }
}); 